import { Popup } from 'components/Popup'
import { Typography } from 'components/Typography'
import { useBankAccountPopup } from './Providers/BankAccountPopupProvider'
import { BUTTON_TYPES, Button } from 'components/Button'
import { BTN_TXT, NOTIFICATIONS } from 'constants/txt'
import { useCallback } from 'react'
import { setLoading } from 'redux/store/common/slice'
import { deleteBankAccountDetails } from './api'
import { useDispatch } from 'react-redux'
import { notification } from 'antd'

export const DeleteBankAccount = ({ onSuccess }: { onSuccess: () => void }) => {
  const {
    deleteBankAccountPopup: { state, actions }
  } = useBankAccountPopup()

  const { name, uuid, business_account_id } = state.payload

  const dispatch = useDispatch()

  const onDelete = useCallback(async () => {
    if (!uuid || !business_account_id) return
    try {
      dispatch(setLoading(true))
      await deleteBankAccountDetails(uuid, business_account_id)
      onSuccess()
    } catch (error) {
      console.error(error)
      notification.error({
        message: NOTIFICATIONS.BANK_ACCOUNT_DELETE_ERROR
      })
    } finally {
      dispatch(setLoading(false))
      actions.close()
    }
  }, [uuid, business_account_id, dispatch, onSuccess, actions])

  return (
    <Popup
      {...state}
      zIndex={10000}
      onCancel={actions.close}
      footer={
        <>
          <Button type={BUTTON_TYPES.DEFAULT} onClick={actions.close} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button
            type={BUTTON_TYPES.PRIMARY}
            onClick={onDelete}
            upperCase
            danger
          >
            {BTN_TXT.DELETE}
          </Button>
        </>
      }
    >
      <Typography.Body1>
        {name} will be permanently deleted. Do you want to proceed?
      </Typography.Body1>
    </Popup>
  )
}
